import React, { useEffect } from 'react';
import { About } from './components/About';
import { Tools } from './components/Tools';
import { Brands } from './components/Brands';
import { Impact } from './components/Impact';
import { Newsletter } from './components/Newsletter';
import { Contact } from './components/Contact';
import { Navigation } from './components/Navigation';
import { PortfolioSlider } from './components/PortfolioSlider';
import { AnimatePresence } from 'framer-motion';
export function App() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <AnimatePresence data-id="element-0">
      <main className="min-h-screen w-full bg-white text-gray-900 overflow-x-hidden" data-id="element-1">
        <Navigation data-id="element-2" />
        <PortfolioSlider data-id="element-3" />
        <About data-id="element-4" />
        <Tools data-id="element-5" />
        <Brands data-id="element-6" />
        <Impact data-id="element-7" />
        <Newsletter data-id="element-8" />
        <Contact data-id="element-9" />
      </main>
    </AnimatePresence>;
}